import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

/*
	cartId
		ID! required
    The ID of the cart.

	discountCodes
		[String!]! required
    The discount codes to apply to the cart.
*/

const cartDiscountCodesUpdate = (
	`mutation ($cartId: ID!, $discountCodes: [String!]!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
		cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartDiscountCodesUpdate;
